import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  industriesSectionContent,
  promotionalBannerSectionContent,
  proTipsSectionContent,
  serviceTipsSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/document-storage-and-archiving-page'

interface DocumentStorageAndArchivingPageProps {}

const DocumentStorageAndArchivingPage: React.FC<DocumentStorageAndArchivingPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
            w-[324px] h-[218px] 
            md-mn:w-[380px] md-mn:h-[286px] 
            lg:!w-[448px] lg:!h-[313px] 
            xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[342px] xl-min:!h-[50px] w-[294px] h-[44px]'
      />
      <WhyWeSection isBgDark {...whyWeSectionContent} className='xl-min:[&_button]:!w-[311px] [&_button]:w-[292px]' />
      <ServiceTipsSectionSection {...serviceTipsSectionContent} />
      <HelperSection
        isBgDark
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
        className={`
            [&_ul]:space-y-3
            lg-mn:[&>div>div:last-of-type>div]:!flex-row
            [&>div>div:last-of-type>div]:flex-col
            xl-min:[&_button]:!w-[230px]
            [&_button]:w-[264px]
            `}
        sectionTitleClassName='w-full'
      />
      <WhyWeSection
        {...proTipsSectionContent}
        className='
            [&_article]:bg-transparent 
            [&_article]:border-none 
            [&_article]:text-center
            [&_article_div]:self-center
            [&_article_img]:w-[130px]
            [&_article_img]:h-[130px]
            '
      />
      <ServiceTipsSectionSection
        isBgDark
        {...industriesSectionContent}
        className='
            [&_article]:bg-transparent 
            [&_article]:border-none 
            [&_article]:text-center
            [&_article_div]:self-center
        '
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
            xl-min:[&_h3]:!max-w-[600px] 
            md-mn:[&_h3]:max-w-[400px] 
            md-mn:[&_h3]:mx-0
            [&_h3]:w-[90%]
            [&_h3]:mx-auto
            xl-min:[&_button]:!w-[224px]
            [&_button]:w-[214px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default DocumentStorageAndArchivingPage
